export const ChartData = [
  {
    id: 1,
    Branch: "CSE (170)",
    Strength: 170,
  },
  { id: 2, Branch: "IT (77)", Strength: 77 },
  { id: 3, Branch: "ECE (158)", Strength: 158 },
  { id: 4, Branch: "EE (160)", Strength: 160 },
  { id: 5, Branch: "CE (158)", Strength: 158 },
  { id: 6, Branch: "ME (152)", Strength: 152 },
  { id: 7, Branch: "Chemical (69)", Strength: 69 },
];

export const ChartDataCourse = [
  {
    id: 1,
    Course: "B.Tech. (1155)",
    TotalIntake: 1155,
  },
  { id: 2, Course: "BBA (94)", TotalIntake: 94 },
  { id: 3, Course: "B.Pharma. (94)", TotalIntake: 94 },
  { id: 4, Course: "MCA (75)", TotalIntake: 75 },
  { id: 5, Course: "MBA (75)", TotalIntake: 75 },
  { id: 6, Course: "M.Sc. (90)", TotalIntake: 90 },
  { id: 7, Course: "M.Tech. (216)", TotalIntake: 216 },
];

export const ChartDataPG = [
  {
    id: 1,
    Course: "M.Tech. (216)",
    TotalIntake: 216,
  },
  { id: 2, Course: "MCA (75)", TotalIntake: 75 },
  { id: 3, Course: "MBA (75)", TotalIntake: 75 },
  { id: 4, Course: "M.Sc. (90)", TotalIntake: 90 },
];
